import { motion } from 'framer-motion'
import { styled } from 'styled-components'

import { mq } from 'styles/mq'
export const ShareContainer = styled.div`
  position: relative;
  text-align: center;
  min-width: 48px;
  overflow: hidden;
  margin-top: -6rem;
  ${mq.medium} {
    margin-top: -10rem;
  }
  ${mq.large} {
    margin-top: -12rem;
  }
`

export const ButtonShareMenu = styled(motion.button)`
  border: none;
  margin: 3.6rem auto;
  ${mq.small} {
    margin-block: 4.2rem;
  }
  ${mq.medium} {
    margin-block: 6rem;
  }
  padding: 8px 24px;
  min-height: 35px;
  font-size: 16px;
  color: var(--primary-color);
  border: 1px solid rgba(239, 43, 46, 0.5);
  background: transparent;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 2px;
  cursor: pointer;
  position: relative;
  transition: background 0.5s;
  &:hover {
    background: rgba(239, 43, 46, 0.05);
  }
`

export const FooterMenu = styled(motion.div)`
  position: absolute;
  top: 3.6rem;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  ${mq.small} {
    gap: 12px;
    top: 4rem;
  }
  ${mq.medium} {
    gap: 14px;
    top: 5.4rem;
  }
`

export const ButtonShare = styled(motion.a)`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--background);
  background: var(--grey);
  font-size: 2.4rem;
  text-decoration: none;
  ${mq.small} {
    width: 42px;
    height: 42px;
    font-size: 3.2rem;
  }
  ${mq.medium} {
    width: 48px;
    height: 48px;
    font-size: 3.6rem;
  }
  transition: opacity 0.5s;
  &:hover {
    opacity: 0.8 !important;
  }
`
export const ButtonClose = styled(motion.button)`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--background);
  background: var(--grey);
  font-size: 1.6rem;
  text-decoration: none;
  cursor: pointer;
  border: none;
  ${mq.small} {
    width: 42px;
    height: 42px;
    font-size: 1.8rem;
  }
  ${mq.medium} {
    width: 48px;
    height: 48px;
    font-size: 2rem;
  }
  transition: opacity 0.5s;
  &:hover {
    opacity: 0.8 !important;
  }
`
